import { SCATTERPLOT_CHART, BAR_CHART, HISTOGRAM_CHART, LINE_CHART, PARALLEL_COORDINATES_CHART } from "../Canvas/Constants";
import { BrushingDataSet, brushingDataset, BrushingPointsLineChart} from "../../Globals/Globals";
import * as aggregation from "../aggregation/countAggregation";
import {HscatterPlotElements, HbarChartElements, HbarChartResizeYAxis, HhistogramElements, HbarChartElementsCount, HLineChartResizeYAxis, HbarChartElementsAvg} from '../Brushing/HistogramBrushElements'
import * as d3 from "d3";
import {findMaxForBarChart, lineChartBrushElements, removeBrushElements, histogramBrushElements, parallelCoordinatesBrushElements, scatterPlotElements}  from '../Brushing/BrushingElements'
import {PREDICTION_COLOR,REALDATA_COLOR,BRUSHING_COLOR,NO_PREDICTION_COLOR} from '../../Globals/ColorConstants'
import {SbarChartElements, SremoveScatterPlotBrushElements} from '../Brushing/ScatterPlotBrushElements'

export function lineChartBrush(ggraphbrushEnable, currentID, brushingPointsLineChart: BrushingPointsLineChart, brushingDataset: BrushingDataSet){

    
    if(ggraphbrushEnable == 0 || ggraphbrushEnable == 1)
    {

        var xaxis = brushingDataset.getBrushingLineChartAxis().xaxis 
        var yaxis = brushingDataset.getBrushingLineChartAxis().yaxis
        var datasetwise = aggregation.allValues
        var datasetIds = []
       
      
        for (var entry in datasetwise)
        {
            var dataRecord = datasetwise[entry]
            var xValue = Number.parseFloat(dataRecord[xaxis])
             if(xValue>=brushingPointsLineChart.startX && xValue<=brushingPointsLineChart.endX)
            {
                datasetIds.push(dataRecord["ID"])
            }
        }
       

     
        removeBrushElements(currentID)
        brushingDataset.getActualMap().forEach(function(datasetValue, datasetKey, map) {
                  
            if(datasetKey != currentID)
            {

                if (datasetValue.type == SCATTERPLOT_CHART)
                {   
                    scatterPlotElements([],datasetKey)
                                      
                    scatterPlotElements(datasetIds,datasetKey)
                    
                }
                else if (datasetValue.type == HISTOGRAM_CHART)
                {
                        
                    histogramBrushElements(datasetValue.xaxis,datasetKey, datasetIds, datasetValue)       

                }
                else if (datasetValue.type == BAR_CHART)
                {   
                

                    var maxValue = findMaxForBarChart(datasetIds, 
                        datasetValue.linearXScale, 
                        datasetValue.linearYScale, 
                        datasetValue.xaxis, 
                        datasetValue.yaxis,
                        datasetValue, datasetKey)
                    console.log('maxValuebrushingPointsHistogramArray',maxValue)   
                        
                    
                    
                }
                else if (datasetValue.type == LINE_CHART) {

                                     
                    lineChartBrushElements(datasetIds, datasetKey, datasetValue) 
                }
                else if (datasetValue.type == PARALLEL_COORDINATES_CHART) {

                    parallelCoordinatesBrushElements(datasetIds, datasetKey, datasetValue) 

                    
                }
            }
        }
        );
    }
    else
    {   
        removeBrushElements(currentID)
    }
}

